import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"
import CustomerCreate from "./customer-create"
import CustomerUpdate from "./customer-update"
import { Customer } from "@/api/customers"

interface CustomersEditSheetProps {
  id?: string;
  open: boolean;
  onDone: (customer?: Customer) => void;
}

export function CustomersEditSheet({
  id,
  open,
  onDone,
}: CustomersEditSheetProps) {
  const title = id === "create" ? "Add Customer" : "Edit Customer"

  return (
    <Sheet open={open} onOpenChange={() => onDone()}>
      <SheetContent className="w-full md:w-5/12 md:max-w-xl">
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        {id && (
          <div className="flex flex-grow overflow-scroll p-1">
            {id === "create" ? (
              <CustomerCreate onDone={onDone} />
            ) : (
              <CustomerUpdate id={id!} onDone={onDone} />
            )}
          </div>
        )}
      </SheetContent>
    </Sheet>
  )
}
